import { useQueryParams, StringParam } from "use-query-params";

export function useOrderQueryToken(): string | undefined {
  const [queryParams] = useQueryParams({
    token: StringParam,
  });
  return queryParams.token;
}
